import { render, staticRenderFns } from "./MatriculasTotaisCard.vue?vue&type=template&id=13773a99&scoped=true"
import script from "./MatriculasTotaisCard.vue?vue&type=script&lang=js"
export * from "./MatriculasTotaisCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasTotaisCard.vue?vue&type=style&index=0&id=13773a99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13773a99",
  null
  
)

export default component.exports